/**
 * @generated SignedSource<<49540700d401fd592e227bd17b8e5a48>>
 * @relayHash b53ee0baddb9bb52902b65cc1ddf8947
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b53ee0baddb9bb52902b65cc1ddf8947

import { ConcreteRequest } from 'relay-runtime';
export type PickupPartnerVideoCallInput = {
  id: string;
};
export type usePickupPartnerVideoCallMutation$variables = {
  input: PickupPartnerVideoCallInput;
};
export type usePickupPartnerVideoCallMutation$data = {
  readonly pickupPartnerVideoCall: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null;
    readonly startVideoCallOutput: {
      readonly roomSid: string;
      readonly sofiaUserToken: string;
    } | null;
  };
};
export type usePickupPartnerVideoCallMutation = {
  response: usePickupPartnerVideoCallMutation$data;
  variables: usePickupPartnerVideoCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PickupPartnerVideoCallPayload",
    "kind": "LinkedField",
    "name": "pickupPartnerVideoCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StartVideoCallOutput",
        "kind": "LinkedField",
        "name": "startVideoCallOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roomSid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sofiaUserToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePickupPartnerVideoCallMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePickupPartnerVideoCallMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b53ee0baddb9bb52902b65cc1ddf8947",
    "metadata": {},
    "name": "usePickupPartnerVideoCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "18e87c5fb84823cd51975affd39e4def";

export default node;
